import gql from 'graphql-tag'

export default gql`
    extend type Query {
        bosSaving: Boolean!
        appError: AppError!
        navHistory: NavHistory!
        notifications: [Notification]!
        modals: [Modal]!
        scrollTarget: ScrollTarget!
    }

    extend type AppError {
        type: String!
        code: String!
        message: String!
        displayMethod: String!
        data: Object!
    }

    extend type Modal {
        name: String!
        data: Object!
    }

    extend type Notification {
        type: String!
        message: String!
        title: String!
    }
    
    extend type NavHistory {
        historyIndex: Number!
        history: Array!
    }

    extend type ScrollTarget {
        name: String!
    }
`
